import PdfBuilder from "./builder";
import * as _ from 'lodash';

export const getScaledDimensions = (realDimensions:any, targetDimensions:any, scaleBasedOn:string) => {
    let aspectRatio = realDimensions.width/ realDimensions.height;
    let scaledWidth, scaledHeight;
    if(scaleBasedOn == 'height') {
       scaledHeight = targetDimensions.height;
       scaledWidth = aspectRatio * scaledHeight;
    } else {
      let aspectRatioForWidth  =  realDimensions.height / realDimensions.width
      scaledWidth =  targetDimensions.width;
      scaledHeight = aspectRatioForWidth * scaledWidth;
    }
    return  {
      scaledWidth,
      scaledHeight
    } 
}

export const copyBuilderInstance = (obj: any) => {
  let clone: any = {};
  let keysToOriginal = ['doc'];
 
    // Iterate over the object's keys
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            // Check if the key should be deep cloned
            if (keysToOriginal.includes(key)) {
              clone[key] = obj[key]; // Shallow copy (retain reference)           
            } else {
              clone[key] = _.cloneDeep(obj[key]); // Deep clone the value
            }
        }
    }
    return clone;
}